import { css } from 'styled-components';
import {
  getTypography,
  TypographyName,
  ThemedFunctor,
  getSpacing,
  SpacingName,
  BreakpointQueryName,
} from '@doveit/lego';
import variables from '../../../themes/variables';

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginBottom(theme, SpacingName.MEDIUM)}
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  ${getTypography(theme, TypographyName.H2)}
  color: ${theme.palettes.brand.primary};
`;

export const relatedArticles: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;

export const footer: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
`;

export const categories: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
`;

export const categoryItem: ThemedFunctor = ({
  theme,
}) => css`
  display: inline-block;
  margin-right: .7rem;
  margin-top: .7rem;

  a {
    text-decoration: none;
    color: ${theme.palettes.brand.primary};
    line-height: 1rem;
    border: 2px solid ${theme.palettes.brand.primary};
    border-radius: 1rem;
    display: inline-block;
    padding: .2rem .7rem;
  }
`;

export const stickySideAdv: ThemedFunctor = ({
  theme,
  $visible,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  display: none;
  position: sticky;
  transition: opacity .4s ease-out;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
    opacity: ${$visible ? 1 : 0};
    pointer-events: ${$visible ? 'all' : 'none'};
    top: calc(${variables.navigationHeight.desktop} + ${theme.spaceUnits.desktop.MEDIUM});
  }
`;
